import accountSafe from './es/account-safe'
import affiliate from './es/affiliate'
import bankTransfer from './es/bankTransfer'
import cart from './es/cart'
import cartAndWarehouse from './es/cartAndWarehouse'
import common from './es/common'
import consult from './es/consult'
import debt from './es/debt'
import distribution from './es/distribution'
import emailSend from './es/emailSend'
import estimation from './es/estimation'
import form from './es/form'
import home from './es/home'
import kol from './es/kol'
import order from './es/order'
import orderDetail from './es/orderDetail'
import packages from './es/package'
import pay from './es/pay'
import pecenter from './es/pecenter'
import points from './es/points'
import previewPackage from './es/previewPackage.json'
import previewPackageOptimize from './es/previewPackageOptimize'
import product from './es/product'
import returnChange from './es/returnChange'
import search from './es/search'
import shareCoupon from './es/shareCoupon'
import sharePackage from './es/sharePackage'
import shoppingGuide from './es/shoppingGuide'
import site from './es/site'
import status from './es/status'
import storage from './es/storage'
import tag from './es/tag'
import tips from './es/tips'
import transport from './es/transport'
import uniOrder from './es/uniOrder'
import vip from './es/vip'
import warnTips from './es/warnTips'
export default {
  'account-safe': accountSafe,
  form,
  home,
  search,
  cart,
  product,
  order,
  pecenter,
  pay,
  common,
  estimation,
  packages,
  orderDetail,
  warnTips,
  status,
  tips,
  storage,
  uniOrder,
  bankTransfer,
  distribution,
  site,
  consult,
  previewPackage,
  sharePackage,
  debt,
  previewPackageOptimize,
  points,
  shareCoupon,
  shoppingGuide,
  tag,
  cartAndWarehouse,
  affiliate,
  returnChange,
  transport,
  kol,
  vip,
  emailSend,
}
